import Loadable from '../../components/loadable';

const DeleteExerciseConfirmationModal = Loadable({
  loader: () => import('react/pages/workouts/delete_exercise_confirmation_modal'),
  type: 'drawer',
});

angular.module('gym').value('DeleteExerciseConfirmationModal', DeleteExerciseConfirmationModal);
